__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "next";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/cache", "11.11.0", function() { return function() { return __webpack_require__(5852); }; }, 1);
			register("@emotion/react", "11.10.8", function() { return function() { return __webpack_require__(196); }; }, 1);
			register("@emotion/styled", "11.10.8", function() { return function() { return __webpack_require__(5879); }; }, 1);
			register("next/dynamic", "14.2.33", function() { return __webpack_require__.e(953).then(function() { return function() { return __webpack_require__(4953); }; }); });
			register("next/head", "14.2.33", function() { return __webpack_require__.e(368).then(function() { return function() { return __webpack_require__(3368); }; }); });
			register("next/image", "14.2.33", function() { return Promise.all([__webpack_require__.e(965), __webpack_require__.e(78)]).then(function() { return function() { return __webpack_require__(9965); }; }); });
			register("next/link", "14.2.33", function() { return Promise.all([__webpack_require__.e(519), __webpack_require__.e(725)]).then(function() { return function() { return __webpack_require__(1106); }; }); });
			register("next/router", "14.2.33", function() { return Promise.all([__webpack_require__.e(519), __webpack_require__.e(884), __webpack_require__.e(715), __webpack_require__.e(78)]).then(function() { return function() { return __webpack_require__(6715); }; }); });
			register("next/script", "14.2.33", function() { return Promise.all([__webpack_require__.e(884), __webpack_require__.e(78), __webpack_require__.e(165)]).then(function() { return function() { return __webpack_require__(8133); }; }); });
			register("react-dom/client", "18.2.0", function() { return Promise.all([__webpack_require__.e(593), __webpack_require__.e(78)]).then(function() { return function() { return __webpack_require__(5338); }; }); });
			register("react-dom", "18.2.0", function() { return function() { return __webpack_require__(961); }; }, 1);
			register("react/jsx-runtime", "18.2.0", function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(4848); }; }); });
			register("react", "18.2.0", function() { return function() { return __webpack_require__(6540); }; }, 1);
			register("styled-jsx/style", "5.1.1", function() { return __webpack_require__.e(513).then(function() { return function() { return __webpack_require__(2513); }; }); });
			register("styled-jsx", "5.1.1", function() { return __webpack_require__.e(816).then(function() { return function() { return __webpack_require__(4435); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};